import { createGtag } from 'vue-gtag';
import * as Sentry from '@sentry/vue';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import { config } from '@/kernel/config';

import './assets/main.css';

const app = createApp(App);

if (config.sentryDsn) {
  Sentry.init({
    app,
    dsn: config.sentryDsn
  });
}

app.use(router);

if (config.googleAnalyticsId) {
  const gtag = createGtag({
    tagId: config.googleAnalyticsId
  });
  
  app.use(gtag);
}

app.mount('#app');
